import { AxiosResponse } from 'axios';

import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

export const postUploadUsers = async (
	FormData: FormData,
): Promise<ResponseREST> => {
	return axiosInstance
		.post('upload-user', FormData, {
			headers: {
				'Content-type': 'multipart/form-data',
			},
		})
		.then((res: AxiosResponse<ResponseREST>) => res.data)
		.catch((err) => err);
};
